import React from 'react';
import FaqsLayout from './faqs-layout';

export default class FaqsOcaso extends React.Component<{}, {}> {
    render(){
        return(
            <FaqsLayout/>
        )
    }
}